import { tr } from '@repo/locale';
import { type TestId } from '@repo/test-id';
import { ProgressBar } from '@repo/ui';

import DashboardGlowingCard from '@features/ownedParkingManage/components/dashboard/DashboardGlowingCard';
import { useDashboardStatsContext } from '@features/ownedParkingManage/contexts/DashboardStatsContext';

interface Props {
  testId: TestId;
}

export default function DashboardSpotsCard({ testId }: Props) {
  const { availableSpots, takenSpots, totalSpots, loading } = useDashboardStatsContext();

  return (
    <DashboardGlowingCard
      title={tr('owned_parking_manage:dashboard.stats.available_spots')}
      counter={availableSpots}
      variant="light"
      loading={loading}
      testId={testId}
    >
      <ProgressBar
        label={tr('owned_parking_manage:dashboard.stats.taken_spots_short')}
        currentValue={takenSpots}
        maximumValue={totalSpots}
        color="success"
        testId={testId.append('progress')}
      />
    </DashboardGlowingCard>
  );
}
